import { Builder } from '@builder.io/sdk';
import { AppDownload, APP_DOWNLOAD_COMPONENT_NAME } from './AppDownload';

export const appDownloadInputs = [
  // Content Section
  {
    name: 'heading',
    type: 'string',
    friendlyName: 'Heading',
    helperText: 'Main heading for the app download section',
    defaultValue: 'Download the Tempcover app',
    required: false,
  },
  {
    name: 'headingLevel',
    type: 'string',
    friendlyName: 'Heading Level',
    helperText:
      "Semantic HTML heading level (h1-h2). Use h1 if this is the main page heading, h2 if there's already an h1 on the page. Important for SEO.",
    enum: ['h1', 'h2'],
    defaultValue: 'h1',
    required: false,
  },
  {
    name: 'subheading',
    type: 'string',
    friendlyName: 'Subheading',
    helperText: 'Supporting text displayed below the heading',
    defaultValue: 'Get covered in seconds and get 30% off the Tempcover fee',
    required: false,
  },
  {
    name: 'mobileButtonText',
    type: 'string',
    friendlyName: 'Mobile Button Text',
    helperText: 'Text displayed on the mobile download button, defaults to "Get the app!"',
    defaultValue: 'Get the app!',
    required: false,
  },
  // URLs Section
  {
    name: 'downloadUrl',
    type: 'url',
    friendlyName: 'App Download URL',
    helperText:
      'URL that redirects users to the appropriate app store based on their device. Used for the mobile button and desktop store badges. Make sure your QR code encodes this same URL.',
    required: true,
    defaultValue: '',
    regex: {
      pattern: '^https?://.*',
      message: 'Please enter a valid URL starting with http:// or https://',
    },
  },
  // Images Section
  {
    name: 'qrCodeImage',
    type: 'file',
    friendlyName: 'QR Code Image',
    helperText:
      'QR code image displayed on desktop that encodes the download URL above. Generate this QR code from your download URL.',
    allowedFileTypes: ['png', 'jpg', 'jpeg', 'svg', 'webp'],
    required: true,
  },
  // Accessibility Section
  {
    name: 'mobileButtonAriaLabel',
    type: 'string',
    friendlyName: 'Mobile Button - Screen Reader Text',
    helperText: 'Accessible label for screen readers. Describes the button action for visually impaired users.',
    defaultValue: 'Download the Tempcover app (opens in new tab)',
    required: false,
    advanced: true,
  },
  {
    name: 'appleStoreAriaLabel',
    type: 'string',
    friendlyName: 'Apple Store Badge - Screen Reader Text',
    helperText: 'Accessible label for screen readers. Describes the Apple App Store download link.',
    defaultValue: 'Download on the iOS App Store',
    required: false,
    advanced: true,
  },
  {
    name: 'googlePlayAriaLabel',
    type: 'string',
    friendlyName: 'Google Play Badge - Screen Reader Text',
    helperText: 'Accessible label for screen readers. Describes the Google Play Store download link.',
    defaultValue: 'Download on Google Play Store',
    required: false,
    advanced: true,
  },
];

const AppDownloadConfig = {
  name: APP_DOWNLOAD_COMPONENT_NAME,
  friendlyName: 'App Download',
  inputs: appDownloadInputs,
};

Builder.registerComponent(AppDownload, AppDownloadConfig);
